/* @flow */
import * as React from "react";
import ScrollableArea from "nexia_mobile/components/Scrollable/ScrollableArea";

let rememberedScrollTops: { [key: string]: number } = {};

type Props = {
  trackingKey: string,
  children?: React.Node,
  style?: Object,
  captureRef?: (?HTMLElement) => void,
};

export default class TrackedScrollableArea extends React.Component<Props> {
  static forgetAll() {
    rememberedScrollTops = {};
  }

  props: Props;
  _div: ?HTMLElement;

  componentDidMount() {
    if (!this._div) {
      return;
    }
    const { trackingKey } = this.props;
    if (trackingKey && rememberedScrollTops[trackingKey]) {
      this._div.scrollTop = rememberedScrollTops[trackingKey];
    }
  }

  componentWillUnmount() {
    if (!this._div) {
      return;
    }
    const { trackingKey } = this.props;
    if (trackingKey) {
      rememberedScrollTops[trackingKey] = this._div.scrollTop;
    }
  }

  render() {
    const {
      children,
      style,
      captureRef,
      // eslint-disable-next-line no-unused-vars
      trackingKey,
      ...otherProps
    } = this.props;

    return (
      <ScrollableArea
        style={style}
        captureRef={(el) => {
          this._div = el;
          if (captureRef) {
            captureRef(el);
          }
        }}
        {...otherProps}
      >
        {children}
      </ScrollableArea>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Scrollable/TrackedScrollableArea.jsx